module.exports = __webpack_public_path__ + "img/GENERAL-IGNIS-3.6bc18398.jpg";